import React, { useContext } from 'react';
import { GlobalContext } from '../context/globalContext';

import { SwitchButton } from '../styles/layOutStyles';

import { BsMoonFill } from 'react-icons/bs';
import { BsSun } from 'react-icons/bs';

const ThemeSwithBtn = () => {
  const { theme, themeSwitchHandler } = useContext(GlobalContext);

  return (
    <SwitchButton>
      <input type='checkbox' onChange={() => themeSwitchHandler(theme === 'dark' ? 'light' : 'dark')} />
      {theme === 'dark' ? <BsSun /> : <BsMoonFill />}
      <span>{theme === 'dark' ? <p>라이트모드</p> : <p>다크모드</p>}</span>
    </SwitchButton>
  );
};

export default ThemeSwithBtn;
